import { useState } from 'react'
import { Stack, styled, SxProps } from '@mui/material'
import { useInView } from 'react-intersection-observer'
import { RawWappMessage, WappMessage } from '@weblite/ts-action/message'
import { WapprunnerCreate as WappRunnerCreate } from 'weblite-web-wapprunner'
import { WappMode } from '@weblite-wapps/protocol'
import { useWapp } from '$logic/wapps/react-hook'
import { WappBar } from '../../components/wapp-bar'

const WAPP_BAR_HEIGHT = 44
const MAX_WAPP_HEIGHT = 400
const MIN_FEASIBLE_SIZE = 100

const Container = styled(Stack)`
  position: relative;
  align-items: center;
  overflow: hidden;
  width: calc(100% - 20px);
  height: 100%;
  box-sizing: unset;
`

export function Wapp({
  attachment,
  statusComp,
  rootStyle,
  messageObj,
}: {
  attachment: RawWappMessage['attachment']
  statusComp: JSX.Element | null
  rootStyle?: SxProps
  messageObj: WappMessage
}) {
  const { iid, roomId } = messageObj
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore // TODO: check why wapp message attachment is optional
  const { wappId, wisId, width, height } = attachment

  // const containerRef = useRef<HTMLDivElement>(null)

  const [isObserved, setIsObserved] = useState(false)
  const { ref: containerRef } = useInView({
    skip: isObserved,
    onChange: inView => {
      if (inView) {
        setIsObserved(true)
      }
    },
  })

  const clampedWidth = Math.min(280, width)
  const clampedHeight = Math.min(
    MAX_WAPP_HEIGHT,
    height * (clampedWidth / width),
  )

  const { entity: wapp, loading } = useWapp(wappId) || {}
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { hideHeader } = wapp || {}

  /**
   * How to use HeightSlope. (not used so far)
   *
   * === NO heightSlope ===
   * `width` and `height` are necessary
   *
   * height(CONST_HEIGHT)
   * constant used to edit dynamic generated height can be also negative,
   * it will be clamped by (MAX_FEASIBLE_HEIGHT=600px).
   *
   * width(CONST_WIDTH)
   * maximum define width when no heightSlope is set
   * it will be clamped by (MAX_FEASIBLE_WIDTH=min(78% of chat_size, 320px)).
   *
   * === WITH heightSlope ===
   * `width` is optionals and initiated with 0
   *
   * missing width (width=0) cause a wapp to gain maximum possible width
   * that a message can have (MAX_FEASIBLE_WIDTH).
   *
   * height can be set to fixed value or use in responsive manner via width calculated ratio.
   * minimum height for wapp is 10 pixel so lower height are ignored internally
   */
  // () => ({
  //   width: width ? `${width}px` : '100%',
  //   height:
  //     heightSlope != null
  //       ? `calc(100% * ${heightSlope} + (${height}px))`
  //       : width
  //       ? `calc(100% * ${height / width})`
  //       : `${height}px`,
  // }),
  // [width, height, heightSlope],
  // )

  return (
    <>
      <Container
        ref={containerRef}
        sx={{
          ...rootStyle,
          minWidth: `${MIN_FEASIBLE_SIZE}px`,
          minHeight: `${MIN_FEASIBLE_SIZE}px`,
          width: `${clampedWidth}px`,
          height: `${clampedHeight + WAPP_BAR_HEIGHT}px`,
          maxHeight: `${MAX_WAPP_HEIGHT}px`,
        }}
      >
        {!loading && !hideHeader && (
          <WappBar wappId={wappId} wisId={wisId} roomId={roomId} iid={iid} />
        )}
        {isObserved && (
          <WappRunnerCreate
            key={wappId}
            wappId={wappId}
            wisId={wisId}
            mode={WappMode.INLINE}
          />
        )}
      </Container>

      {statusComp ? (
        <div style={{ padding: '7px 10px' }}>{statusComp}</div>
      ) : null}
    </>
  )
}

Wapp.defaultProps = {
  rootStyle: null,
}
